export function  isDateEmpty(date){
    let result;
    if (date === "0001-01-01T00:00:00Z") {
      result = "";
    } else {
      result = new Date(date);
    }
    return result;
};